// src/pages/WelcomePage.jsx
import React, { useEffect } from "react";
import { Box, Button, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

function WelcomePage() {
  const navigate = useNavigate();

  // 🔐 If already logged in, skip welcome and go to app
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.id) {
      navigate("/app", { replace: true });
    }
  }, [navigate]);

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography variant="h3" color="primary" gutterBottom>
        Welcome to LifeShot
      </Typography>

      <Box mt={4} display="flex" flexDirection="column" gap={2} width="100%">
        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          onClick={() => navigate("/login")}
        >
          Login
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          size="large"
          fullWidth
          onClick={() => navigate("/signup")}
        >
          Sign Up
        </Button>
      </Box>
    </Container>
  );
}

export default WelcomePage;
